<template>
  <v-card class="cause-card" :style="`background-image: url(${logo})`">
    <div class="d-flex flex-no-wrap justify-space-between">
      <v-card-text class="pa-0">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title style="color: #4A4A4A;" class="headline">{{ title }}</v-list-item-title>
            <v-list-item-subtitle style="color: #808080">{{ subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-row align="center" class="pa-4 pt-0">
          <v-col class="d-flex align-baseline primary--text">
            <div class="display-4 mr-3 font-weight-regular" :class="`${color}--text`">
              {{ number }}
              <v-icon color="primary" x-large>
                {{icon}}
              </v-icon>
            </div>
            <div class="display-3 font-weight-regular" :class="`${color}--text`">{{ description }}</div>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ['logo','title','subtitle','number','description','color','icon']
}
</script>

<style lang="scss" scoped>
.cause-card {
  background-size: contain;
  background-position: right;

  & > div {
    background: rgba(white, 0.9);
    background-position: right;
    background-size: contain;
  }
}

.cause-card:hover{
    filter: drop-shadow(0px 4px 4px rgba(0,0,0,0.15));
    transition: all ease 0.2s;
}

</style>